import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Avatar, Dropdown, Space, Typography, Divider } from 'antd';
import type { MenuProps } from 'antd';
import {
  UserOutlined,
  LockOutlined,
  LogoutOutlined,
  DownOutlined,
} from '@ant-design/icons';
import { useAuth } from '../context/AuthContext';
import { useTranslation } from 'react-i18next';

const { Text } = Typography;

const UserProfileDropdown: React.FC = () => {
  const { user, logout } = useAuth();
  const { t } = useTranslation();
  const navigate = useNavigate();

  const displayName = user?.full_name || user?.username || 'User';
  const avatarLetter = displayName.charAt(0).toUpperCase();

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  const items: MenuProps['items'] = [
    {
      key: 'info',
      label: (
        <div style={{ padding: '4px 0' }}>
          <Text strong style={{ fontSize: 14, color: '#F1F5F9' }}>{displayName}</Text>
          <br />
          <Text style={{ fontSize: 12, color: '#8B9BB4' }}>{user?.email || user?.username || ''}</Text>
        </div>
      ),
      disabled: true,
    },
    { type: 'divider' },
    {
      key: 'change-password',
      icon: <LockOutlined />,
      label: t('auth.changePassword') || 'Change Password',
      onClick: () => navigate('/change-password'),
    },
    { type: 'divider', style: { borderColor: 'rgba(255,77,79,0.15)' } },
    {
      key: 'logout',
      icon: <LogoutOutlined />,
      label: <span style={{ color: '#ff4d4f' }}>{t('auth.signOut') || 'Sign Out'}</span>,
      onClick: handleLogout,
    },
  ];

  return (
    <Dropdown menu={{ items }} trigger={['click']} placement="bottomRight">
      <Space
        style={{
          cursor: 'pointer',
          padding: '4px 12px',
          borderRadius: 8,
          transition: 'background 0.2s',
        }}
        className="user-profile-trigger"
      >
        <Avatar
          size={32}
          icon={<UserOutlined />}
          style={{
            backgroundColor: '#0052FF',
            color: '#fff',
            fontWeight: 600,
          }}
        >
          {avatarLetter}
        </Avatar>
        <span style={{ color: '#F1F5F9', fontSize: 14, fontWeight: 500 }}>
          {displayName}
        </span>
        <DownOutlined style={{ color: '#8B9BB4', fontSize: 10 }} />
      </Space>
    </Dropdown>
  );
};

export default UserProfileDropdown;
